module.exports = __webpack_public_path__ + "img/small-door.79f43fa3.png";